import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check_fill",
  "use": "check_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check_fill\">\r\n    <path d=\"M512 108.128C288.256 108.128 106.848 288.96 106.848 512c0 223.072 181.408 403.872 405.152 403.872 223.808 0 405.152-180.864 405.152-403.872 0-223.04-181.344-403.872-405.152-403.872z m-46.624 611.84L269.44 523.936l33.824-18.048 154.272 124.64c40.448-56.8 152.736-204.16 278.72-314.176l18.976 22.016c-129.184 124.768-236.8 305.984-289.856 381.6z\" p-id=\"10833\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol